if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      const quickAddModal = this.closest('quick-add-modal');
      const upsellModal = document.querySelector('product-upsell-modal');

      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: config.headers,
          body: formData
        });
        const json = await response.json();

        // Handle error from Shopify
        if (json.status) {
          this.handleErrorMessage(json.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          return;
        }

        // --- Upsell workflow ---
        if (!quickAddModal && upsellModal && upsellModal.showUpsell && window.productCollections?.length) {
          const eligibleRule = window.productCollections.find(rule => rule.getCollectionHandle);
          if (!window.DEBUG_UPSELL) {
              console.log('[Upsell] Skipped because DEBUG_UPSELL = false');
              // Do NOT show upsell → fall through to normal cart drawer
          } else {
            if (eligibleRule) {
              upsellModal.showUpsell(eligibleRule);

              // const onUpsellClose = async () => {
              //   upsellModal.removeEventListener('modalClosed', onUpsellClose);
              //   if (this.cart) await this.refreshCartDrawer();
              // };

              // upsellModal.addEventListener('modalClosed', onUpsellClose, { once: true });
              // return; // Prevent immediate drawer open
            }
          }
        }

        // --- Quick Add Modal workflow ---
        if (quickAddModal) {
          // const isInsideUpsell = this.dataset.isUpsellForm === "true";

          // if (isInsideUpsell) {
          //   // Quick Add inside Upsell Modal → only show messaging, do NOT open drawer
          //   quickAddModal.hide(false); // keep focus until modal closed
          //   return;
          // } else {
          //   // Normal Quick Add → update drawer immediately
          //   if (this.cart) await this.refreshCartDrawer(json);
          //   quickAddModal.hide(false);
          //   return;
          // }

          if (this.cart) await this.refreshCartDrawer(json);
          quickAddModal.hide(false);
          return;
        }

        // --- Normal add to cart ---
        if (this.cart) await this.refreshCartDrawer(json);

      } catch (e) {
        console.error(e);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }

    async refreshCartDrawer(cartJson = null) {
      if (!this.cart) return;

        try {
          const sectionsToRender = this.cart.getSectionsToRender().map(s => s.id);
          const response = cartJson || await fetch(`${routes.cart_url}?sections=${sectionsToRender.join(',')}&sections_url=${window.location.pathname}`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          const json = cartJson || await response.json();

          if (json?.sections) {
            this.cart.renderContents(json);
          } else {
            console.warn('Cart sections missing:', json);
          }
        } catch (err) {
          console.error('Error refreshing cart drawer', err);
        }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
